<lib-frame-menu [frontendVersion]="frontendVersion">
  <mat-nav-list class="main-menu">
    <mat-list-item routerLink="/home" routerLinkActive="router-link-active">
      <span class="list-item bigger-font"><mat-icon>dashboard</mat-icon>Dashboard</span>
    </mat-list-item>
    @if ([AlmaboxPermissions.machine] | hasPermission | async) {
      <mat-list-item (click)="toggleMachineMenu()">
        <span class="list-item bigger-font menu-group">
          <span class="list-item"><mat-icon>computer</mat-icon>Macchine</span>
          <mat-icon class="expand-icon" [class.rotated]="machineMenuExpanded">expand_more</mat-icon>
        </span>
      </mat-list-item>
      <div class="submenu" [class.expanded]="machineMenuExpanded">
        <mat-list-item routerLink="/frame/entity/machine" routerLinkActive="router-link-active" [routerLinkActiveOptions]="{exact: true}">
          <span class="list-item bigger-font nested-item"><mat-icon>computer</mat-icon>Macchine</span>
        </mat-list-item>
        <mat-list-item routerLink="/frame/entity/machine/deleted" routerLinkActive="router-link-active">
          <span class="list-item bigger-font nested-item"><mat-icon>restore_from_trash</mat-icon>Macchine eliminate</span>
        </mat-list-item>
      </div>
    }
    @if ([AlmaboxPermissions.family] | hasPermission | async) {
      <mat-list-item routerLink="/frame/entity/family" routerLinkActive="router-link-active">
        <span class="list-item bigger-font"><mat-icon>group_work</mat-icon>Famiglie</span>
      </mat-list-item>
    }
  </mat-nav-list>
</lib-frame-menu>
